import z from "zod";

const translationPath =
  "page.4uDlist.listImportAutomation.dlist_classifications.errors.";

const listClassificationSchema = z.object(
  {
    id: z.string(),
    name: z.string().min(1),
    code: z.number().optional(),
  },
  { invalid_type_error: translationPath + "list_classification" }
);

export const classificationSchema = z.object({
  listClassification: listClassificationSchema,
});

export type TClassificationForm = z.infer<typeof classificationSchema>;
